import { cedeErrors } from "@cede/types";
import { AnyErrorObject } from "@cede/utils";
import { sanitizeErrors } from "@cede/utils/src/error/cedeErrors";

export const CedeErrors = sanitizeErrors(cedeErrors as unknown as AnyErrorObject);
